enum Branch {
  TOTAL = 'TOTAL',
  LIFE = 'VIDA',
  NO_LIFE = 'NO VIDA'
}

export default Branch;
